
export { OrderPriceInfoRow } from "/home/runner/work/ravago-digital-platform/ravago-digital-platform/libs/shared/page-elements-radiance/src/lib/components/shared/order/order-price-info-row.tsx"